import React from 'react';

export const AssignmentsFeature = React.lazy(() => import('./pages/AssignmentsFeature'));
